/**
 * Merging ATLAS validation messages for a single form field.
 *
 * ATLAS reports one error per rule that fires, so a field failing thirty rules
 * comes back with "Required data field" thirty times. Concatenating them
 * verbatim produced a wall of the same sentence repeated across the error
 * panel. Distinct messages are still worth showing — they say different things
 * about the same field — so only exact repeats are dropped.
 */

/** Separator between distinct messages for one field. */
export const ERROR_SEPARATOR = '; ';

/**
 * Append `message` to the errors already recorded for `path`, skipping it when
 * that exact text is already present. Returns the merged string.
 */
export function mergeFieldError(existing: string | undefined, message: string): string {
  const incoming = (message || '').trim();
  if (!incoming) return existing || '';
  if (!existing) return incoming;
  const seen = existing.split(ERROR_SEPARATOR).map((s) => s.trim());
  if (seen.includes(incoming)) return existing;
  return `${existing}${ERROR_SEPARATOR}${incoming}`;
}

/** In-place `mergeFieldError` for the `Record<string, string>` error maps. */
export function appendFieldError(
  map: Record<string, string>,
  path: string,
  message: string,
): void {
  const merged = mergeFieldError(map[path], message);
  if (merged) map[path] = merged;
}
